<template>
  <h2 class="pb-2 border-bottom">General Primary Care</h2>
  <ul>
    <li>Virtual consultations for common illnesses (cold, flu, allergies)</li>
    <li>Prescription refills and medication management</li>
    <li>Chronic disease follow-ups (diabetes, hypertension, thyroid disorders)</li>
    <li>Preventive health counseling</li>
  </ul>

  <h2 class="pb-2 border-bottom">Weight Loss & Metabolic Health</h2>
  <ul>
    <li>Virtual consultations for Ozempic prescriptions & monitoring</li>
    <li>Online diet and nutrition counseling</li>
    <li>Hormone-related weight loss treatments</li>
  </ul>

  <h2 class="pb-2 border-bottom">Men’s & Women’s Health</h2>
  <ul>
    <li>Hormone Replacement Therapy (HRT) follow-ups</li>
    <li>Testosterone Replacement Therapy (TRT) monitoring</li>
    <li>Menopause & PCOS management</li>
  </ul>

  <h2 class="pb-2 border-bottom">Mental Health & Lifestyle Coaching</h2>
  <ul>
    <li>Anxiety & depression management</li>
  </ul>
</template>

<script>
export default {
  name: 'TelemedicineContentEn'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
